import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { SharedModule } from "src/app/shared/shared.module";
import { DeviceTypesRoutingModule } from "./device-types-routing.module";
import { DeviceTypesComponent } from "./device-types.component";
import { AddDeviceTypeComponent } from './add-device-type/add-device-type.component';

@NgModule({
    declarations: [
      DeviceTypesComponent,
      AddDeviceTypeComponent
    ],
    imports: [
      CommonModule,
      DeviceTypesRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      NgbModule,
      LoaderModule,
      SharedModule
    ]
  })
  export class DeviceTypesModule { }